



























import { Component, Prop, Vue } from 'vue-property-decorator'

import AppTextInput from '@/components/AppTextInput.vue'

@Component({
  components: {
    AppTextInput
  }
})
export default class extends Vue {
  @Prop(Boolean) readonly isTextarea!: boolean
  @Prop(String) readonly placeholder!: string
  @Prop(String) readonly value!: string
  @Prop(String) readonly status!: string
  @Prop(String) readonly checkedText!: string
  @Prop(String) readonly invalidText!: string
  @Prop(String) readonly guideText!: string
}
